import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { PackageAssignConfigData } from './package-assign-config-data';

@Injectable({
  providedIn: 'root'
})
export class PackageAssignmentModalService extends BaseModalService<PackageAssignConfigData> {}
